const btn = document.querySelector('.site-footer__top-locations-button');
const panel = document.getElementById('footer-locations-panel');
const closeBtn = document.querySelector('.site-footer__top-locations-close');

if (btn && panel) {
	function togglePanel() {
		const isOpen = panel.classList.toggle('is-open');
		btn.setAttribute('aria-expanded', isOpen);
		panel.setAttribute('aria-hidden', !isOpen);

		if (isOpen && window.innerWidth < 1024) {
			const btnRect = btn.getBoundingClientRect();
			panel.style.top = (btnRect.bottom + 12) + 'px';
		} else {
			panel.style.top = '';
		}
	}

	btn.addEventListener('click', togglePanel);
	if (closeBtn) closeBtn.addEventListener('click', togglePanel);

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && panel.classList.contains('is-open')) {
			togglePanel();
		}
	});

	document.addEventListener('click', function (e) {
		if (panel.classList.contains('is-open') && !panel.contains(e.target) && !btn.contains(e.target)) {
			togglePanel();
		}
	});
}
